import { Component, OnInit } from '@angular/core';
import { EncryptionSecretService } from '../../_services/encryption-secret.service';
import { AuthService } from 'src/app/_services/auth.service';
import { Role } from 'src/app/_helpers/auth.constants';

@Component({
  selector: 'app-encryption-secret',
  templateUrl: './encryption-secret.component.html',
  styleUrl: './encryption-secret.component.css'
})
export class EncryptionSecretComponent implements OnInit {
  aesKey: string | null = null;
  saltSecret: string | null = null;
  copiedKey: 'aes' | 'salt' | null = null;

  constructor(
    private readonly encryptionSecretService: EncryptionSecretService,
    private readonly authService: AuthService
  ) { }

  ngOnInit(): void {
    if (this.authService.getRole() == Role.PAY10_ADMIN) {
      this.aesKey = '••••••••••••••••••••••••••••••••';
      this.saltSecret = '••••••••••••••••••••••••••••••••';
      return;
    }
    this.encryptionSecretService.loadEncryptionSecrets().subscribe(response => {
      this.aesKey = response.aesKey;
      this.saltSecret = response.secretKey;
    });
  }

  copySecret(value: any, key: 'aes' | 'salt'): void {
    navigator.clipboard.writeText(value).then(() => {
      this.copiedKey = key;
      setTimeout(() => this.copiedKey = null, 2000);
    });
  }


}
